'use client';

import stepCommonClassName from '@/app/_lens-components/style/step-common';
import Image from '@/components/Image';
import { useMediaQuery } from '@mui/material';
import { RightArrowOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';

interface ScanItemProps {
  onClick: () => void;
  prescriptionItemClassName: string;
  iconContainerClassName: string;
  textClassName: string;
  prImageClassName: string;
}

export default function ScanItem({
  onClick,
  prescriptionItemClassName,
  iconContainerClassName,
  textClassName,
  prImageClassName,
}: ScanItemProps) {
  const t = useTranslations('lens-process');
  const isWap = useMediaQuery('(max-width:1280px)');

  return (
    <div className={`${prescriptionItemClassName} ml-[8px] basis-[100px]`} onClick={onClick}>
      <div className={iconContainerClassName}>
        <Image
          src="/lens-process/scan_pres.png"
          alt={t('prescription')}
          className={prImageClassName}
          width={40}
          height={40}
        />
      </div>
      <div className={textClassName}>
        {`${t('scan')} `}
        <br className="xl:hidden" />
        {t('myPrescription')}
      </div>
      {!isWap && <RightArrowOutlined className={stepCommonClassName.arrowIcon} />}
    </div>
  );
}
